import { performSearch } from './searchService';

describe('performSearch', () => {
  const defaultParams = {
    searchUrl: '/internal_admin/error_log_lookup/search',
    csrfToken: 'test-csrf-token',
    errorId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    traceId: '6aa06477000000000bef57f1e5d87355',
    timeRange: '24h',
  };

  beforeEach(() => {
    global.fetch = jest.fn();
  });

  afterEach(() => {
    jest.restoreAllMocks();
  });

  it('returns parsed JSON on successful response', async () => {
    const responseData = {
      events: [{ '@id': '1', message: 'test event' }],
      anchor_id: '1',
    };

    global.fetch.mockResolvedValue({
      ok: true,
      status: 200,
      json: () => Promise.resolve(responseData),
    });

    const result = await performSearch(defaultParams);

    expect(result).toEqual(responseData);
  });

  it('sends correct headers', async () => {
    global.fetch.mockResolvedValue({
      ok: true,
      status: 200,
      json: () => Promise.resolve({}),
    });

    await performSearch(defaultParams);

    expect(global.fetch).toHaveBeenCalledWith(
      defaultParams.searchUrl,
      expect.objectContaining({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': defaultParams.csrfToken,
        },
      }),
    );
  });

  it('sends correct body with error_id, trace_id, and time_range', async () => {
    global.fetch.mockResolvedValue({
      ok: true,
      status: 200,
      json: () => Promise.resolve({}),
    });

    await performSearch(defaultParams);

    const callArgs = global.fetch.mock.calls[0];
    const body = JSON.parse(callArgs[1].body);

    expect(body).toEqual({
      error_id: defaultParams.errorId,
      trace_id: defaultParams.traceId,
      time_range: defaultParams.timeRange,
    });
  });

  it('sends null trace_id when traceId is empty', async () => {
    global.fetch.mockResolvedValue({
      ok: true,
      status: 200,
      json: () => Promise.resolve({}),
    });

    await performSearch({ ...defaultParams, traceId: '' });

    const callArgs = global.fetch.mock.calls[0];
    const body = JSON.parse(callArgs[1].body);

    expect(body.trace_id).toBeNull();
  });

  it('triggers window.location.reload and returns null on 401 response', async () => {
    const reloadMock = jest.fn();
    Object.defineProperty(window, 'location', {
      writable: true,
      value: { reload: reloadMock },
    });

    global.fetch.mockResolvedValue({
      ok: false,
      status: 401,
      json: () => Promise.resolve({}),
    });

    const result = await performSearch(defaultParams);

    expect(reloadMock).toHaveBeenCalled();
    expect(result).toBeNull();
  });

  it('throws error with message from response body on non-ok response', async () => {
    global.fetch.mockResolvedValue({
      ok: false,
      status: 500,
      json: () => Promise.resolve({ error: 'Log query timed out.' }),
    });

    await expect(performSearch(defaultParams)).rejects.toThrow(
      'Log query timed out.',
    );
  });

  it('throws generic "Search failed." when response body has no error message', async () => {
    global.fetch.mockResolvedValue({
      ok: false,
      status: 500,
      json: () => Promise.resolve({}),
    });

    await expect(performSearch(defaultParams)).rejects.toThrow(
      'Search failed.',
    );
  });
});
